import { SkeletonPlaceholder } from '@carbon/react';
import {
  documentDateRangeAtom,
  searchAtom,
} from 'components/documents-search/atoms';
import { formatNumber } from 'components/search/common/format-helpers';
import { subDays } from 'date-fns';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';

import style from './document-stats.module.scss';
import { useDocumentsCountAtom } from '../common/atoms';

interface DocumentStats {
  total: number;
  last24h: number;
  last7d: number;
}

export const DocumentStats = () => {
  const searchResult = useAtomValue(searchAtom);
  const setDateRange = useSetAtom(documentDateRangeAtom);
  const documentsCountAtom = useDocumentsCountAtom();
  const [documentsCount] = useAtom(documentsCountAtom);

  const getCount = () => {
    if (!documentsCount.data || 'error' in documentsCount.data) return 0;
    return documentsCount.data.count;
  };

  const get24HCount = () => {
    if (!documentsCount.data || 'error' in documentsCount.data) {
      return 0;
    }
    return documentsCount.data.count24h;
  };

  const get7DCount = () => {
    if (!documentsCount.data || 'error' in documentsCount.data) {
      return 0;
    }
    return documentsCount.data.count7d;
  };

  const handleDateFilter = (days: number) => {
    const endDate = new Date();
    const startDate = subDays(endDate, days);

    // Set new date range
    const newDateRange = {
      start: startDate.toISOString(),
      end: endDate.toISOString(),
    };

    // Update both the shared atom and search payload
    setDateRange(newDateRange);
  };

  return (
    <div className={style.statsArea}>
      <div className={style.statBox}>
        <div className={style.statLabel}>Total Documents</div>
        <div className={style.statValue}>
          {searchResult.loading ? (
            <SkeletonPlaceholder className={style.placeholderSkeletonItem} />
          ) : (
            formatNumber(getCount())
          )}
        </div>
      </div>
      <div
        className={style.statBox}
        onClick={() => handleDateFilter(1)}
        style={{ cursor: 'pointer' }}
      >
        <div className={style.statLabel}>Last 24 Hours</div>
        <div className={style.changeValue}>
          {searchResult.loading ? (
            <SkeletonPlaceholder className={style.placeholderSkeletonItem} />
          ) : (
            `+${formatNumber(get24HCount())}`
          )}
        </div>
      </div>
      <div
        className={style.statBox}
        onClick={() => handleDateFilter(7)}
        style={{ cursor: 'pointer' }}
      >
        <div className={style.statLabel}>Last 7 Days</div>
        <div className={style.changeValue}>
          {searchResult.loading ? (
            <SkeletonPlaceholder className={style.placeholderSkeletonItem} />
          ) : (
            `+${formatNumber(get7DCount())}`
          )}
        </div>
      </div>
    </div>
  );
};
